import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faBoxOpen, faFootballBall } from '@fortawesome/free-solid-svg-icons';

const gameIcons = {
  roulette_edge: faCircleNotch,
  cases_edge: faBoxOpen,
  sportsbook_edge: faFootballBall,
};

function HouseEdge({ competitor }) {
  // Dynamically filter the house edge fields
  console.log("HouseEdge component mounted with competitor:", competitor);
  const houseEdges = Object.entries(competitor)
    .filter(([key, value]) => key.endsWith('_edge') && value !== null)
    .map(([key, value]) => ({
      game: key.replace('_edge', '').replace('_', ' '), // Format the game name
      edge: value,
      icon: gameIcons[key], // Select the matching icon
    }));

  if (houseEdges.length === 0) {
    return <p className="text-gray-400">No house edge data available for this competitor.</p>;
  }

  return (
    // Overflow wrapper to allow horizontal scrolling if widgets become wider than the container
    <div className="overflow-x-auto">
      {/* 
        The grid below uses an arbitrary grid-template-columns value:
        - auto-fit: auto-fits as many columns as possible.
        - minmax(max-content, 1fr): ensures that each grid item is never smaller than its content's intrinsic width (so words won't break)
          but will stretch up to 1fr if extra space is available.
      */}
      <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(max-content,1fr))]">
        {houseEdges.map(({ game, edge, icon }) => (
          <div
            key={game}
            className="flex items-center p-4 bg-neutral-800 rounded-lg shadow-lg hover:bg-neutral-700 transition duration-200"
          >
            <FontAwesomeIcon icon={icon} className="text-2xl text-green-400 mr-4" />
            <div>
              {/* whitespace-nowrap prevents text from wrapping onto a new line */}
              <p className="text-sm font-bold capitalize whitespace-nowrap">{game}</p>
              <p className="text-sm text-gray-400 whitespace-nowrap">{edge}%</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HouseEdge;
